import React from 'react';
import { PersonaInfo, PersonaLabel } from '~/interfaces';
import { EMPTY_FN } from '~/constants';

const PersonaContext = React.createContext<{
    personaInfo?: PersonaInfo;
    setPersonaInfo: (value: PersonaInfo) => void;
    personaLabel?: PersonaLabel;
}>({
    setPersonaInfo: EMPTY_FN
});

PersonaContext.displayName = 'PersonaContext';
export default PersonaContext;
